import { warning,blue } from '../../../utils/sitecolors'

export default 
{
	notFound: {
		color:warning,
		fontSize:'115%',
		paddingLeft:'30px' 
	},
	tableHeader: { 
		textAlign:'left',
		backgroundColor:'white',
		color:blue
	},
	saveButton: { 
		marginTop:'10px',
		color:blue 
	}

}


// WEBPACK FOOTER //
// ./src/components/pages/Athlete/styles.js